import { __spreadArray } from "tslib";
import { isFeatureEnabled } from '@wix/answers-experiments';
import { TsUtils } from '../../../test-utils';
export var defaultAutoRoutingFeatureSettings = {
    enabled: true,
    maxWorkload: 5,
    maxSecondsToAccept: 50
};
export var SupportedFeatures;
(function (SupportedFeatures) {
    SupportedFeatures[SupportedFeatures["TICKETING"] = 10] = "TICKETING";
    SupportedFeatures[SupportedFeatures["CALL_CENTER"] = 20] = "CALL_CENTER";
    SupportedFeatures[SupportedFeatures["CHAT"] = 30] = "CHAT";
    SupportedFeatures[SupportedFeatures["FACEBOOK"] = 40] = "FACEBOOK";
    SupportedFeatures[SupportedFeatures["WHATSAPP"] = 50] = "WHATSAPP";
    SupportedFeatures[SupportedFeatures["SMS"] = 60] = "SMS";
    SupportedFeatures[SupportedFeatures["KNOWLEDGEBASE"] = 70] = "KNOWLEDGEBASE";
    SupportedFeatures[SupportedFeatures["TWITTER"] = 80] = "TWITTER";
    SupportedFeatures[SupportedFeatures["INSTAGRAM"] = 90] = "INSTAGRAM";
})(SupportedFeatures || (SupportedFeatures = {}));
export var getAllSupportedFeatures = function () {
    var disabledFeatures = __spreadArray([], (isFeatureEnabled('TwitterTicket') ? [] : [SupportedFeatures.TWITTER]), true);
    return TsUtils.enumToArray(SupportedFeatures).filter(function (key) {
        return !disabledFeatures.includes(key);
    });
};
//# sourceMappingURL=index.js.map